// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__tRAod"};